import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { contactInfo } from '../mock';

const Footer = () => {
  return (
    <footer className="bg-kato-navy text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Logo and Description */}
          <div className="col-span-1 md:col-span-2">
            <img 
              src="https://customer-assets.emergentagent.com/job_kato-mito-upgrade/artifacts/llbvcjnh_IMG_0805.png" 
              alt="Kato Mito" 
              className="h-12 w-auto mb-4"
            />
            <p className="text-gray-300 text-sm leading-relaxed mb-4">
              Premium Swedish-style candy wholesale. Creating memorable confectionery experiences 
              with bold flavors, clean design, and exceptional quality.
            </p>
            <p className="text-kato-cyan text-sm font-medium">
              More than candy. A sophisticated sweet escape.
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact</h3>
            <div className="space-y-3">
              <div className="flex items-center text-gray-300 text-sm">
                <Mail size={16} className="mr-2 text-kato-cyan" />
                <a href={`mailto:${contactInfo.email}`} className="hover:text-kato-yellow transition-colors">
                  {contactInfo.email}
                </a>
              </div>
              <div className="flex items-center text-gray-300 text-sm">
                <Phone size={16} className="mr-2 text-kato-cyan" />
                <a href={`tel:${contactInfo.phone}`} className="hover:text-kato-yellow transition-colors">
                  {contactInfo.phone}
                </a>
              </div>
              <div className="flex items-start text-gray-300 text-sm">
                <MapPin size={16} className="mr-2 text-kato-cyan mt-0.5" />
                <span>{contactInfo.address}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2025 Kato Mito. All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <a href="#" className="text-gray-400 hover:text-kato-yellow transition-colors text-sm">
              Privacy Policy
            </a>
            <a href="#" className="text-gray-400 hover:text-kato-yellow transition-colors text-sm">
              Terms of Service
            </a>
            <a href="#" className="text-gray-400 hover:text-kato-yellow transition-colors text-sm">
              Wholesale Terms
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;